import { useState } from 'react'
import { useIntl } from '@/intl'

export function useThrottleTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    invalidCredentials: translate({ id: 'login-next.login.submit.errors.invalid' }),

    attemptsRemaining: (count: number) =>
      translate({ id: 'login-next.login.submit.errors.attemptsRemaining', values: { count } }),

    // countdown-free: announced once when the lockout banner mounts, so it must
    // not contain anything that changes while the clock ticks
    lockedAnnouncement: translate({ id: 'login-next.login.submit.errors.lockedAnnouncement' }),

    lockedLive: (countdown: string) =>
      translate({ id: 'login-next.login.submit.errors.lockedLive', values: { countdown } }),

    lockedStatic: (unlockTime: string) =>
      translate({ id: 'login-next.login.submit.errors.lockedStatic', values: { unlockTime } }),

    wasntYou: translate({ id: 'login-next.login.submit.errors.wasntYou' }),
    resetPassword: translate({ id: 'login-next.login.submit.errors.resetPassword' }),
  }))

  return api
}
